import { Alert, useMediaQuery, useTheme } from '@mui/material'
import * as Icons from '@mui/icons-material'
import { TpTooltip } from '~/components'
import { DESKTOP_BREAKPOINT } from '~/common/constants/layout-constants'

/**
 * Responsive severity banner — icon-only on mobile (tooltip), full message on desktop.
 *
 * @param {'error'|'warning'|'info'|'success'} severity
 * @param {string} message
 */
export const TpBanner = ({ severity, message }) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up(DESKTOP_BREAKPOINT))

  const icon = severity === 'error'
    ? <Icons.ErrorOutline fontSize="inherit" />
    : <Icons.WarningAmber fontSize="inherit" />

  return (
    <TpTooltip
      title={isDesktop ? null : message}
      slotProps={{
        popper: {
          sx: {
            '& .MuiTooltip-tooltip': {
              border: '1px solid',
              borderColor: theme.palette[severity]?.main || `${severity}.main`
            }
          }
        }
      }}
    >
      <Alert
        severity={severity}
        icon={icon}
        sx={{
          width: 'fit-content',
          minWidth: 0,
          alignSelf: 'center',
          alignItems: 'center',
          py: { xs: '4px', [DESKTOP_BREAKPOINT]: 0 },

          '& .MuiAlert-message': {
            display: { xs: 'none', [DESKTOP_BREAKPOINT]: 'flex' },
            alignItems: 'center',
            whiteSpace: 'pre-line'
          },

          '& .MuiAlert-icon': {
            mr: { xs: 0, [DESKTOP_BREAKPOINT]: '0.75rem' },
            p: '4px 0'
          },
        }}
      >
        {message}
      </Alert>
    </TpTooltip>
  )
}
